export default "__VITE_ASSET__ea58ce95__"